/** zh-CN catalogue `ops` (W3-09; English: src/core/ops/ops.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'ops',
  locale: 'zh-CN',
  messages: {
    stale: '项目在此期间已被修改，无法应用此更改。请重试。',
  },
};

export default catalog;
